import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AddAppointment from "./AddAppoinment";
import { Endpoints } from "../Global/Endpoints";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

const CancelAppointment = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true); // Updated to true for initial loading state
  const navigate = useNavigate();
  const emailId = useSelector((state) => state.userData?.userData?.EmailID);
  const token = localStorage.getItem("AccessToken");
  const [refreshKey, setRefreshKey] = useState(0);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const token = localStorage.getItem("AccessToken");

        const params = {
          Email: emailId,
        };

        const response = await axios.post(
          Endpoints.fetchAppointments,
          { _Params: JSON.stringify(params) },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Connection": "close",
              Accept: "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data && Array.isArray(response.data)) {
          setAppointments(response.data);
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Failed to fetch appointments:", error);
      } finally {
        setLoading(false); // Ensure loading is set to false after data is fetched
      }
    };

    if (emailId) {
      fetchAppointments();
    }
  }, [emailId, refreshKey]);

  const handleAddAppointment = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const handleBackClick = () => {
    navigate("/home");
  };

  return (
    <>
      <div className="col-md-6 mt-4 inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}>
          <span>
            <i className="bi bi-chevron-left"></i> Back
          </span>
        </button>
        <h2 className="page-heading">Cancel Appointment</h2>
      </div>

      <div className="col-md-12 mt-4">
        {loading ? (
          <div className="skeleton-loader">
            <p>Loading appointments...</p>
            {/* Add your skeleton UI design here */}
            {[...Array(3)].map((_, index) => (
              <div key={index} className="skeleton-item">
                <div className="skeleton-heading"></div>
                <div className="skeleton-details"></div>
              </div>
            ))}
          </div>
        ) : appointments.length > 0 ? (
          <div>
            {appointments.map((appointment, index) => (
              <div key={index} className="appointment-item">
                <p>
                  <strong>{appointment.ProviderName}</strong>
                  <br />
                  <div className="appointment-details">
                {t('appointmentScheduled', {
                  slotType: appointment.SlotType,
                  date: appointment.SelectedDate,
                  time: appointment.Time,
                  timeZone: appointment.TimeZoneName
                })}
                </div>
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p>No upcoming appointments</p>
        )}

        <button onClick={handleAddAppointment} className="win-btn-primary">
          Add Provider Appointment
        </button>
        {isPopupOpen && (
          <AddAppointment isOpen={isPopupOpen} onClose={handleClosePopup} />
        )}
      </div>
    </>
  );
};

export default CancelAppointment;
